import { Component, ElementRef, ViewEncapsulation, input, viewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { ApRadioButtonComponent } from '@ap/radio';

@Component({
    selector: 'ap-radio-card',
    templateUrl: './radio-card.component.html',
    styleUrls: ['./radio-card.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApRadioButtonComponent, ReactiveFormsModule]
})
export class ApRadioCardComponent {
    private readonly radioButton = viewChild(ApRadioButtonComponent, { read: ElementRef });

    /**
     * Required - Name of radio group
     */
    public readonly name = input.required<string>();

    /**
     * Required - Value of radio button
     */
    public readonly value = input.required<any>();

    /**
     * FormControl to bind to
     */
    public readonly control = input<FormControl<string>>(new FormControl());

    /**
     * Label of selection to show behind radio / checkbox
     */
    public readonly selectionLabel = input<string>(undefined);

    /**
     * Url of the image source (asset)
     */
    public readonly imageSource = input<string>(undefined);

    /**
     * Alt text for the image
     */
    public readonly alt = input<string>(undefined);

    /**
     * Unique id of field that can be used to map aria fields
     */
    protected uniqueId = `radio-card-${Math.round(Math.random() * 10000000)}`;

    /**
     * Set value of card and focus input
     * @internal
     */
    public selectCard(value: any) {
        this.control().setValue(value);
        this.radioButton().nativeElement.querySelector('input').focus();
    }
}
